export class SsiDropdownItem <T> {
  Value: T;
  Name: string;
}
